
var utils = {
  wait(time) {
    return new Promise((resovle) => {
      setTimeout(resovle, time);
    });
  },

  auth: {
    fetchCurrentUser() {
      var id = app.store.currentUser.id;
      return app.store.collection('users').doc(id).fetch();
    },
  },
  sanitizeHTML(text) {
    return String(text)
      .replace(/&/g,"&amp;")
      .replace(/"/g,"&quot;")
      .replace(/'/g,"&#039;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;");
  },

  async uploadImage(file, filename) {
    var ref = firebase.storage().ref();
    var id = app.store.currentUser.id;
    var snapshot = await ref.child(id).child('' + Date.now()).child(filename || file.name).put(file);
    var url = await snapshot.ref.getDownloadURL();
    return url;
  },

  //- ユニークな文字列を生成する
  getUniqId() {
    var num = 1000;
    return new Date().getTime().toString(16) + Math.floor(num * Math.random()).toString(16);
  },

  downloadFile(filename, value) {
    var url = URL.createObjectURL(new Blob([value]), { type: 'text/plain' });
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.click();
    URL.revokeObjectURL(url);
  },

  unique(arr, callback) {
    if (!callback) return [...new Set(arr)];
    const map = new Map();
    for (const obj of arr) map.set(callback(obj), obj);
    return [...map.values()];
  },

  sortUserName(users) {
    return [...users].sort((a, b) => {
      if (a.id === app.auth.currentUser.uid) {
        return -1;
      }
      else if (b.id === app.auth.currentUser.uid) {
        return 1;
      }
      else {
        return a.data.screen_name.toLowerCase() < b.data.screen_name.toLowerCase() ? -1 : 1;
      }
    });
  },
  
  // プロジェクトのデフォルトカラー
  defaultColor: "#96969C",
};

utils.path = require('path');

export default utils;

